export const libraryKeys = {
  all: ['quiz-library'] as const,
  search: () => [...libraryKeys.all, 'search'] as const,
} as const;
